import React from 'react';
import PropTypes from 'prop-types';
import { resolve } from '@cvent/nucleus-dynamic-css';
import { resolveTestId } from '@cvent/nucleus-test-automation';
import addUrlDefaultProtocol from '../../utils/addUrlDefaultProtocol';

/**
 * The Image widget.
 */
export default class Image extends React.Component {
  static displayName = 'Image';
  static propTypes = {
    imgUrl: PropTypes.string,
    altText: PropTypes.string,
    hyperlink: PropTypes.string,
    description: PropTypes.string,
    translate: PropTypes.func.isRequired
  };
  render() {
    const { imgUrl, altText, description, hyperlink, translate } = this.props;
    const image = imgUrl ? <img src={translate(imgUrl)} alt={altText} title={altText} />
      : <div {...resolve(this.props, 'placeholder')} />;
    return (
      <div {...resolveTestId(this.props)} {...resolve(this.props, 'container')}>
        <div {...resolve(this.props, 'image', !imgUrl && 'limitSize')}>
          <div {...resolve(this.props, 'imageWrapper')}>
            { hyperlink ? <a href={translate(addUrlDefaultProtocol(hyperlink))} target="_blank">{image}</a> : image }
          </div>
          {description &&
            <div {...resolve(this.props, 'imageText')}
              dangerouslySetInnerHTML={{ __html: description }}
            />}
        </div>
      </div>
    );
  }
}
